import React, { useContext } from 'react';

import { observer } from 'mobx-react-lite';
import { Navigate } from 'react-router-dom';

import { RootStoreContext } from 'index';
import { ApplicationRoute } from 'routes/routes.enums';
import AccountMayExist from 'components/prequalification/EntryFormResult/Slides/AccountMayExist';

import styles from './EntryFormResult.module.scss';
import { EntryFormResultStatus } from '../prequalification.enums';
import DisabledUser from './Slides/DisabledUser';
import ExistingIntermediary from './Slides/ExistingIntermediary';
import RejectedIntermediary from './Slides/RejectedIntermediary';

const EntryFormResult = () => {
  const { prequalificationStore } = useContext(RootStoreContext);
  const { mainContact, assignedTeamMember, entryFormStatus } = prequalificationStore;

  if (!mainContact || !assignedTeamMember) {
    return <Navigate to={ApplicationRoute.Prequalification}></Navigate>;
  }

  return (
    <div className={styles.pageContainer}>
      <div className={styles.headerTitle}>Next Step</div>
      <div className={styles.entryForm}>
        {[EntryFormResultStatus.Active, EntryFormResultStatus.PendingUser].includes(entryFormStatus!) && (
          <AccountMayExist assignedTeamMember={assignedTeamMember} />
        )}
        {entryFormStatus === EntryFormResultStatus.RejectedIntermediary && <RejectedIntermediary />}
        {entryFormStatus === EntryFormResultStatus.DisabledUser && <DisabledUser />}
        {entryFormStatus === EntryFormResultStatus.ExistingIntermediary && (
          <ExistingIntermediary assignedTeamMember={assignedTeamMember} />
        )}
      </div>
    </div>
  );
};

export default observer(EntryFormResult);
